/** Resultaatkaart van de feedbackcontrole: per feedbackpunt de status met bewijs. */
import React from 'react';
import { Paper, Box, Typography, Chip, Stack } from '@mui/material';

const STATUS = {
  verwerkt: { label: 'Verwerkt', bg: '#ecfdf5', color: '#047857' },
  niet_verwerkt: { label: 'Niet verwerkt', bg: '#fef2f2', color: '#b91c1c' },
  onzeker: { label: 'Onzeker', bg: '#fffbeb', color: '#b45309' },
  niet_controleerbaar: { label: 'Handmatig checken', bg: '#f1f5f9', color: '#475569' },
};
const mmss = (s) => `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, '0')}`;

export default function FeedbackCheckResultaat({ resultaat, onSeek }) {
  if (!resultaat?.punten?.length) return null;
  const t = resultaat.telling || {};
  return (
    <Paper variant="outlined" sx={{ borderRadius: 2, mb: 3, overflow: 'hidden' }}>
      <Box sx={{ px: 2.5, py: 1.5, bgcolor: '#f8fafc', borderBottom: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <Typography variant="subtitle1" fontWeight={800}>🔁 Feedbackcontrole</Typography>
        <Typography variant="caption" color="text.secondary">{resultaat.bron_label} · {String(resultaat.uitgevoerd_op || '').slice(0, 16).replace('T', ' ')}</Typography>
        <Box sx={{ flex: 1 }} />
        {Object.entries(STATUS).map(([k, m]) => t[k] ? <Chip key={k} size="small" label={`${t[k]} ${m.label.toLowerCase()}`} sx={{ bgcolor: m.bg, color: m.color, fontWeight: 700 }} /> : null)}
      </Box>
      {(!resultaat.had_transcript || !resultaat.had_frames) && (
        <Typography variant="caption" sx={{ display: 'block', px: 2.5, pt: 1, color: '#b45309' }}>
          Let op: {!resultaat.had_transcript ? 'geen transcript' : ''}{!resultaat.had_transcript && !resultaat.had_frames ? ' en ' : ''}{!resultaat.had_frames ? 'geen keyframes' : ''} beschikbaar voor deze versie; de beoordeling is daardoor beperkt.
        </Typography>
      )}
      <Stack divider={<Box sx={{ borderTop: '1px solid #f1f5f9' }} />}>
        {resultaat.punten.map((p) => {
          const m = STATUS[p.status] || STATUS.onzeker;
          return (
            <Box key={p.nr} sx={{ px: 2.5, py: 1.5, display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
              <Chip size="small" label={m.label} sx={{ bgcolor: m.bg, color: m.color, fontWeight: 700, minWidth: 120 }} />
              <Box sx={{ flex: 1 }}>
                <Typography variant="body2" fontWeight={700}>
                  {p.nr}. {p.tekst}
                  {p.seconden != null && (
                    <Chip size="small" label={mmss(p.seconden)} onClick={() => onSeek?.(p.seconden)}
                      sx={{ ml: 1, height: 20, fontFamily: 'monospace', fontSize: 11, cursor: 'pointer' }} />
                  )}
                </Typography>
                {p.toelichting && <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>{p.toelichting}</Typography>}
                {p.bewijs && <Typography variant="caption" sx={{ display: 'block', mt: 0.5, fontFamily: 'monospace', color: '#475569', bgcolor: '#f8fafc', px: 1, py: 0.5, borderRadius: 1 }}>{p.bewijs}</Typography>}
              </Box>
              {p.vertrouwen > 0 && <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>{Math.round(p.vertrouwen * 100)}%</Typography>}
            </Box>
          );
        })}
      </Stack>
    </Paper>
  );
}
